import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { GlossRoutes, MainSettingsRoute } from "../../models/enum/routes.enum";

/** Settings › Bundles. */
export const BUNDLES_PAGE_ROUTE = ["/", GlossRoutes.Settings, MainSettingsRoute.Plans];

/**
 * The one place an "Upgrade" button decides where to go, so they all land on the same page:
 * Bundles, whose plan dialog starts the 14-day trial too (the checkout goes through
 * PaymentService.handlePlanSubmit and its Stripe session includes the trial).
 */
@Injectable({ providedIn: "root" })
export class UpgradeNavigationService {
  private router = inject(Router);

  /** Templates bind it ([routerLink]). */
  upgradeRoute(): string[] {
    return BUNDLES_PAGE_ROUTE;
  }

  goToUpgrade(): Promise<boolean> {
    return this.router.navigate(this.upgradeRoute());
  }
}
